// Test hooks for the child components that need to be specifically addressed with a test id
export const TestHooks = {
	ViewFeeBreakdownLink: 'view-fee-breakdown-link',
	Container: 'container',
	Icon: 'icon',
	Icon1: 'icon-1',
	SolidPdfIcon: 'solid-pdf-icon',
	SelectedDocDiv: 'selected-doc-div',
	//	MyHookName: 'myHookIdentifier',
} as const;
/*
NOTE: The above hooks have been auto generated, all naming is a best guess approach.
Please review them, edit where necessary and delete this comment to indicate that the names are correct.
*/
